import { AdminEffects } from '@app/auth/store/effects/admin.effects';
import { ChangeLanguageEffects } from '@app/auth/store/effects/change-language.effects';
import { ChangePasswordEffects } from '@app/auth/store/effects/change-password.effects';
import { HoldingEffects } from '@app/auth/store/effects/holding.effects';
import { LoginByTokenEffects } from '@app/auth/store/effects/login-by-token.effects';
import { LoginEffects } from '@app/auth/store/effects/login.effects';
import { LogoutEffects } from '@app/auth/store/effects/logout.effects';
import { MFAEffects } from '@app/auth/store/effects/mfa.effects';
import { PasswordSettingsEffects } from '@app/auth/store/effects/password-settings.effects';
import { PersistanceEffects } from '@app/auth/store/effects/persistance.effects';
import { RefreshTokenEffects } from '@app/auth/store/effects/refresh-token.effects';
import { ResetPasswordEffects } from '@app/auth/store/effects/reset-password.effects';
import { SetPasswordEffects } from '@app/auth/store/effects/set-password.effects';
import { SsoLoginEffects } from '@app/auth/store/effects/sso-login.effects';
import { TerminalV2Effects } from '@app/auth/store/effects/terminal-v2.effects';
import { TerminalEffects } from '@app/auth/store/effects/terminal.effects';
import { UserInfoEffects } from '@app/auth/store/effects/user-info.effects';
import { VerifyEmailEffects } from '@app/auth/store/effects/verify-email.effects';

export const authEffects = [
  UserInfoEffects,
  LoginEffects,
  LogoutEffects,
  PersistanceEffects,
  RefreshTokenEffects,
  HoldingEffects,
  AdminEffects,
  MFAEffects,
  VerifyEmailEffects,
  ResetPasswordEffects,
  ChangePasswordEffects,
  LoginByTokenEffects,
  SsoLoginEffects,
  SetPasswordEffects,
  PasswordSettingsEffects,
  ChangeLanguageEffects,
  TerminalEffects,
  TerminalV2Effects,
];
